import { css } from 'lit';

export const vaAlertStyles = css`
  :host {
    display: block;
    margin: 0.5rem 0;
  }

  .alert {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    font-size: 0.95rem;
    border: 1px solid var(--wa-color-neutral-border-quiet);
  }

  .success {
    background: var(--wa-color-success-fill-quiet);
    color: var(--wa-color-success-on-quiet);
    border-color: var(--wa-color-success-border-quiet);
  }

  .error {
    background: var(--wa-color-danger-fill-quiet);
    color: var(--wa-color-danger-on-quiet);
    border-color: var(--wa-color-danger-border-quiet);
  }

  .info {
    background: var(--wa-color-neutral-fill-quiet);
    color: var(--wa-color-neutral-on-quiet);
    border-color: var(--wa-color-neutral-border-quiet);
  }

  .warning {
    background: var(--wa-color-warning-fill-quiet);
    color: var(--wa-color-warning-on-quiet);
    border-color: var(--wa-color-warning-border-quiet);
  }

  button {
    margin-left: auto;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
  }
`;
